module.exports = __webpack_public_path__ + "img/ring_r_c_0_null.14674c9c.png";